import styled from "styled-components";

export const EngagementOverviewTableWrapper = styled.div`
    margin-bottom: 32px;
`;

EngagementOverviewTableWrapper.displayName = "EngagementOverviewTableWrapper";

export const EngagementOvertimeWidgetWrapper = styled.div``;
EngagementOvertimeWidgetWrapper.displayName = "EngagementOvertimeWidgetWrapper";

export const AppleGraphWrapper = styled.div`
    padding-bottom: 10px;
`;
AppleGraphWrapper.displayName = "AppleGraphWrapper";

export const MetricField = styled.div`
    display: flex;
    align-items: center;
`;

export const IconWrapper = styled.span`
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-left: 8px;
`;

